import { useState } from "react";
import { api, errText } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Send } from "lucide-react";

// Who gets emailed when a new lead arrives (landing page + realtor Private Client leads).
export const NotificationSettings = ({ s, setS }) => {
  const [sending, setSending] = useState(false);
  const [dirty, setDirty] = useState(false);

  const sendTest = async () => {
    setSending(true);
    try {
      const { id, ...payload } = s;
      await api.put("/settings", payload);
      setDirty(false);
      const { data } = await api.post("/settings/notifications/test");
      toast.success(`Test email sent to ${data.recipients.join(", ")}`);
    } catch (e) {
      toast.error(errText(e));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <Switch
          data-testid="lead-notifications-switch"
          checked={s.lead_notifications_enabled !== false}
          onCheckedChange={(v) => { setS({ ...s, lead_notifications_enabled: v }); setDirty(true); }}
        />
        <Label className="text-sm">Email me every time a new lead comes in</Label>
      </div>
      <div className="space-y-1.5">
        <Label className="text-[11px] uppercase tracking-[0.14em] text-gray-500">Send lead notifications to</Label>
        <Input
          data-testid="notification-emails"
          placeholder="info@arkfurniture.ca, kyle@arkfurniture.ca"
          value={s.notification_emails || ""}
          onChange={(e) => { setS({ ...s, notification_emails: e.target.value }); setDirty(true); }}
          className="rounded-sm h-11"
        />
        <p className="text-xs text-gray-400 leading-relaxed">
          Separate multiple addresses with commas. Applies to landing-page Revival leads and realtor Private Client leads.
          Each email includes the customer's details, photo thumbnails and a one-click link to the lead.
        </p>
      </div>
      <Button data-testid="notification-test-btn" onClick={sendTest} disabled={sending} variant="outline" className="rounded-sm h-11 text-xs uppercase tracking-wider">
        <Send size={13} className="mr-1.5" /> {sending ? "Sending…" : dirty ? "Save & send test email" : "Send test email"}
      </Button>
    </div>
  );
};
